import React from 'react'

const Title = ({
  children
}) => (
  <>
    <h1>
      <span>{ children?.[1]?.props?.children?.[0] }</span>
      { children?.[1]?.props?.children?.[1] }
    </h1>
  </>
  )

export default Title